import React, { useEffect, useState } from "react";
import Chatbot from "./Chatbot";

function App({ helpType, lifeSuiteCode, userRoles, rosiPermissionLevel, managerReviewWriterEnabled }) {
  const [shouldRender, setShouldRender] = useState(true);

  useEffect(() => {
    const blacklistedStrings = ["AlbertaJustice_GL_Prod"];
    const companyName = document.body.innerHTML.match(/"companyName"\s*:\s*"([^"]*)"/)?.[1];

    if (companyName && companyName === blacklistedStrings[0]) {
      setShouldRender(false);
    }
  }, []);

  return (
    <div className="App">
      {shouldRender && <Chatbot helpType={helpType} lifeSuiteCode={lifeSuiteCode} userRoles={userRoles} rosiPermissionLevel={rosiPermissionLevel} managerReviewWriterEnabled={managerReviewWriterEnabled} />}
    </div>
  );
}

export default App;
